
// ─────────────────────────────────────────────
// components/LocationSection.tsx
// ─────────────────────────────────────────────
import React from 'react';
import SimpleKakaoMap from "../../../../components/kakao/SimpleKakaoMap";
import {maskAddressDetail} from "../../../../utils/format";

export const LocationSection: React.FC<{ data: any; maskAddress?: boolean }> = ({ data, maskAddress = false }) => {
    const displayAddressDetail = maskAddress ? maskAddressDetail(data.addressDetail) : data.addressDetail;

    return (
        <section className="bg-white">
            <div className="inner-box">
                <h3 className="cont-tit"><span className="underline">돌봄요청 장소 정보</span></h3>
                <ul className="detail-info mt10">
                    <li><span className="tit">주소</span><span className="txt">{data.address}</span></li>
                    <li><span className="tit">상세주소</span><span className="txt">{displayAddressDetail}</span></li>
                </ul>
            </div>
            <div className="mapWrap">
                {data.address && (
                    <SimpleKakaoMap address={data.address} addressDetail={maskAddress ? '' : data.addressDetail} />
                )}
            </div>
        </section>
    );
};